export enum ELimitationType {
  DEFAULT = "DEFAULT",
  ONLY_GIVE_WARNING = "ONLY_GIVE_WARNING",
  EXCLUDE_FROM_SCHEDULE = "EXCLUDE_FROM_SCHEDULE",
}
